export default function TeamSelection({ setTeam }) {
    return (
      <div className="container">
        <h1 className="text-3xl font-bold mb-6">팀을 선택하세요</h1>
        <button onClick={() => setTeam("red")} className="red-btn">
          🔴 Red 팀 선택
        </button>
        <button onClick={() => setTeam("blue")} className="blue-btn">
          🔵 Blue 팀 선택
        </button>
      </div>
    );
  }
  